import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ScrollToTop } from '@/components/ScrollToTop';
import { CookieBanner } from '@/components/CookieBanner';

export const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Scroll to top on route change (unless there is a hash)
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-[#58677A]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <ScrollToTop />
      <CookieBanner />
    </div>
  );
};
